import { useQuery } from '@tanstack/react-query';

import { adSchema } from '../schema/ad.schema';

import { donedealServicesGateway } from '../../../../api/api-utils/commonApiUtils';

import { API_CLIENT_TIMEOUT } from '../../../../utils';

const getAd = async (id: number) => {
  const { data } = await donedealServicesGateway.get(
    `/ddapi/v1/listings/${id}`,
    {
      timeout: API_CLIENT_TIMEOUT,
    },
  );

  return adSchema.parse(data);
};

export const useGetAd = (id: number) => {
  return useQuery({
    queryKey: ['getAd', id],
    queryFn: () => getAd(id),
  });
};
